import React from 'react';
import { Box } from '@mui/material';
import Eyebrow from './Eyebrow';
import { marketingFonts as F, marketingColors as C } from '../../theme_landing_page';

interface SimplePageHeroProps {
  eyebrow: string;
  title: React.ReactNode;
  body?: string;
  maxWidth?: number;
  bottomPadding?: string;
}

const SimplePageHero: React.FC<SimplePageHeroProps> = ({ eyebrow, title, body, maxWidth = 1000, bottomPadding = '8px' }) => (
  <Box component="section" sx={{ padding: { xs: `120px 24px ${bottomPadding}`, md: `140px 52px ${bottomPadding}` } }}>
    <Box sx={{ maxWidth, margin: '0 auto', textAlign: 'center' }}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <Box
        component="h1"
        sx={{ fontFamily: F.display, fontWeight: 400, fontSize: 'clamp(2.5rem,5vw,4.5rem)', lineHeight: 1.1, letterSpacing: '-0.04em', marginTop: '24px', color: C.ink }}
      >
        {title}
      </Box>
      {body && (
        <Box sx={{ maxWidth: '38rem', margin: '18px auto 0', fontSize: 17, color: C.body }}>{body}</Box>
      )}
    </Box>
  </Box>
);

export default SimplePageHero;
